const storeName = 'ANALYTICS';

export default {
    SET_PAGE_LOAD_INFO: `${storeName}.SET_PAGE_LOAD_INFO`,
    COLLECT_IMPRESSION: `${storeName}.COLLECT_IMPRESSION`,
    SEND_VIEW_EVENT_WAITING: `${storeName}.SEND_VIEW_EVENT_WAITING`,
    SEND_TRANSACTION_WAITING: `${storeName}.SEND_TRANSACTION_WAITING`,
    CLEAR_IMPRESSIONS: `${storeName}.CLEAR_IMPRESSIONS`,
    IMPRESSION_CLICK: `${storeName}.IMPRESSION_CLICK`,
    CHECKOUT_CART_EVENTS: `${storeName}.CHECKOUT_CART_EVENTS`,
    CHECKOUT_PAYMENT_EVENTS: `${storeName}.CHECKOUT_PAYMENT_EVENTS`,
    SET_CURRENT_STEP: `${storeName}.SET_CURRENT_STEP`,
    SET_CHECKOUT_OPTION: `${storeName}.SET_CHECKOUT_OPTION`,
    SET_DELIVERY_OPTION_COMPLETED: `${storeName}.SET_DELIVERY_OPTION_COMPLETED`,
    SET_PAYMENT_OPTION_COMPLETED: `${storeName}.SET_PAYMENT_OPTION_COMPLETED`,
    SET_ADDITIONAL_STEP: `${storeName}.SET_ADDITIONAL_STEP`,
    SET_LOGIN_OPTION: `${storeName}.SET_LOGIN_OPTION`,
    SET_CURRENT_PAGE: `${storeName}.SET_CURRENT_PAGE`,
    SET_CURRENT_PRODUCT_LIST: `${storeName}.SET_CURRENT_PRODUCT_LIST`,
    INCREMENT_CURRENT_WRAPPER_COUNTER: `${storeName}.INCREMENT_CURRENT_WRAPPER_COUNTER`,
    CALCULATE_CURRENT_WRAPPER_COUNTER: `${storeName}.CALCULATE_CURRENT_WRAPPER_COUNTER`,
    SET_WRAPPER: `${storeName}.SET_WRAPPER`,
    RESET_WRAPPERS_BY_TYPE: `${storeName}.RESET_WRAPPERS_BY_TYPE`,
    SET_LOCATION: `${storeName}.SET_LOCATION`,
    PROCEED_PAGELOAD: `${storeName}.PROCEED_PAGELOAD`,
    GIFT_SAMPLE_START: `${storeName}.GIFT_SAMPLE_START`,
    SET_PAGELOAD: `${storeName}.SET_PAGELOAD`,
    SET_MINICART_POPOVER_STATUS: `${storeName}.SET_MINICART_POPOVER_STATUS`,
    SET_ADD_REVIEW_START_TIME: `${storeName}.SET_ADD_REVIEW_START_TIME`,
    SET_REVIEWS_IMPRESSION_VIEW: `${storeName}.SET_REVIEWS_IMPRESSION_VIEW`,
    SET_CC_ERROR: `${storeName}.SET_CC_ERROR`,
    COLLECT_STORY_IMPRESSION: `${storeName}.COLLECT_STORY_IMPRESSION`,
    STORY_IMPRESSION_CLICK: `${storeName}.STORY_IMPRESSION_CLICK`,
    HANDLE_CAMERA_ERROR: `${storeName}.HANDLE_CAMERA_ERROR`,
    HANDLE_CHOOSE_MODIFACE_MODE: `${storeName}.HANDLE_CHOOSE_MODIFACE_MODE`,
};
